// extracted by mini-css-extract-plugin
module.exports = {"home-banner":"style_home-banner__BJPgt","my-dashboard":"style_my-dashboard__4WKWO","value":"style_value__lZo7k","label":"style_label__dILqO","shadow":"style_shadow__iTp8n"};